import { onDomReady } from '../utils/dom';

export class Header {
    static root;
    static inside;
    static container;
    static after;
    static wrapper = null;
    static clone = null;

    // Gets called once when the class is first used.
    static {
        const root = document.getElementById('header');
        const inside = root.querySelector('.header_inside');
        const container = document.getElementById('viewport');
        const after = document.getElementById('title');

        if (!root || !inside || !container || !after) {
            throw new Error('Could not find header elements.');
        }

        this.root = root;
        this.inside = inside;
        this.container = container;
        this.after = after;
    }

    // Get the current height of the header (including contact bar).
    static getHeight = () => this.after.offsetTop.toFixed(0);

    // Get the current height of the header (without contact bar).
    static getInnerHeight = () => this.root.getBoundingClientRect().height.toFixed(2);

    // Get the position from which the header should be fixed.
    static getFixedPosition = () => window.innerHeight / 2;

    /**
     * Calculate the regular height and sticky height of the header.
     * We need to know these values for CSS top offsets.
     */
    static calculateHeights = () => {
        Header.container.style.setProperty('--sticky-height', `${Header.getInnerHeight()}px`);
    };
}

function showFixedHeader() {
    const scrolledTop = document.documentElement.scrollTop;
    const headerHeight = parseInt(Header.getHeight());

    if (scrolledTop > headerHeight) {
        Header.root.classList.add('sticky');
    } else {
        Header.root.classList.remove('sticky');
    }

    if (scrolledTop > Header.getFixedPosition()) {
        Header.root.classList.add('show');
    } else {
        Header.root.classList.remove('show');
    }
}

onDomReady(() => {
    Header.calculateHeights();
    showFixedHeader();
});

window.addEventListener('scroll', () => {
    showFixedHeader();
});

window.addEventListener('resize', () => {
    Header.calculateHeights();
    showFixedHeader();
});
